export function encrypt (text) {
    return window.encryptAes(text);
}

export function makeSecureToken (text) {
    return window.makeSecureToken(text);
}
